/* eslint-disable no-unused-vars */
/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable import/no-unresolved */
import {
    Dispatch,
    ReactNode,
    useEffect,
    useState,
} from 'react';
import Map, { Marker, ViewState } from 'react-map-gl';
import { ICoordinates } from '../../interfaces/map.interface';

interface MapBoxProps {
    apiKey: string;
    center: ICoordinates;
    zoom?: number;
    children?: ReactNode;
    setMapsLoaded?: Dispatch<any>;
    onCenterChanged?: (center: ICoordinates) => void;
}

const MapBox = ({
    apiKey,
    center,
    zoom = 12,
    children = [],
    setMapsLoaded,
    onCenterChanged,
}: MapBoxProps) => {
    const [viewState, setViewState] = useState({
        longitude: center.lng,
        latitude: center.lat,
        zoom,
    });

    let removeUndefined: any = [];
    if (!Array.isArray(children)) {
        removeUndefined = [children];
    } else {
        removeUndefined = children;
    }

    removeUndefined = removeUndefined.filter((child: any) => child);

    const markers = removeUndefined.map((child: any, index: number) => (
        <Marker
            key={child.key || index}
            latitude={child.props.lat}
            longitude={child.props.lng}
        >
            {child}
        </Marker>
    ));

    useEffect(() => {
        setViewState((prev) => ({
            ...prev,
            longitude: center.lng,
            latitude: center.lat,
        }));
    }, [center.lng, center.lat]);

    return (
        <Map
            // @ts-ignore
            mapLib={import('!mapbox-gl')}
            mapboxAccessToken={apiKey}
            viewState={viewState as any}
            style={{ width: '100%', height: '100%' }}
            mapStyle="mapbox://styles/mapbox/light-v11"
            onLoad={(e: any) => {
                const map: any = e.target;
                if (setMapsLoaded) {
                    setMapsLoaded(map);
                }
                if (onCenterChanged) {
                    // @ts-ignore
                    map.on('dragend', () => {
                        // @ts-ignore
                        onCenterChanged({
                            lng: map.getCenter().lng,
                            lat: map.getCenter().lat,
                        });
                    });
                }
            }}
        >
            {markers}
        </Map>
    );
};

export { MapBox };
